import axios from "@/hooks/axios/axios";
import type {
  RateLimitDefaults,
  RateLimitDefaultsPayload,
} from "../types/rate-limit.types";

export const getRateLimitDefaults = async (): Promise<RateLimitDefaults> => {
  const { data } = await axios.get("/rate-limit-settings/defaults");
  return data;
};

export const updateRateLimitDefaults = async (
  payload: RateLimitDefaultsPayload,
): Promise<RateLimitDefaults> => {
  const { data } = await axios.put("/rate-limit-settings/defaults", payload);
  return data;
};
